<template>
  <div>
    <b-row>
      <b-col>
        <h4 class="mt-3">{{ $t("workflow.stageFields") }}</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          hover
          :items="availableFields"
          :fields="previousStageFields"
          selectable
          select-mode="single"
          @row-selected="onSelectAvailable"
        >
        </b-table>
      </b-col>
      <b-col>
        <b-table
          hover
          :items="sortedStageFields"
          :fields="tableFields"
          selectable
          select-mode="single"
          @row-selected="onSelectAdded"
        >
          <template v-slot:cell(displayName)="stageFieldRow">
            {{ getFieldName(stageFieldRow.item) }}
          </template>
          <template v-slot:cell(required)="stageFieldRow">
            <base-required-dropdown
              v-model="stageFieldRow.item.required"
              :fieldType="getFieldType(stageFieldRow.item)"
            >
            </base-required-dropdown>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <!-- <div>{{ availableFields }}</div> -->
    <!-- <div>{{sortedStageFields}}</div> -->
  </div>
</template>
<script>
export default {
  name: "StageCrudFields",
  components: {
    BaseRequiredDropdown: () =>
      import("@/components_rms/base/BaseRequiredDropdown.vue"),
  },
  props: {
    process: Object,
    stage: Object,
  },
  mixins: [],
  data() {
    return {
      previousStageFields: [
        {
          label: this.$t("geral.availableFields"),
          key: "displayName",
          sortable: true,
        },
      ],
      tableFields: [
        {
          label: this.$t("workflow.stageFields"),
          key: "displayName",
          sortable: true,
        },
        {
          label: this.$t("workflow.processField.required"),
          key: "required",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    availableFields() {
      let fields = [];
      let selectedFields = this.stage.fields;
      this.sortedProcessFields.forEach((field) => {
        if (!selectedFields.some((e) => e.fieldId == field.id)) {
          fields.push(field);
        }
      });
      return fields;
    },
    sortedStageFields() {
      let stageFields = [];
      for (let processField of this.sortedProcessFields) {
        let stageField = this.stage.fields.find(
          (e) => e.fieldId == processField.id
        );
        if (stageField) {
          stageFields.push(stageField);
        }
      }
      return stageFields;
    },
    sortedProcessFields() {
      let fields = [];
      this.process.fields.forEach((field) => {
        if (field.active) {
          fields.push(field);
        }
      });
      return fields.sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    },
  },
  mounted: function () {},
  methods: {
    getField(stageField) {
      for (let field of this.process.fields) {
        if (field.id == stageField.fieldId) {
          return field;
        }
      }
      return null;
    },
    getFieldName(stageField) {
      let field = this.getField(stageField);
      if (!field) return "";
      return field.displayName;
    },
    getFieldType(stageField) {
      let field = this.getField(stageField);
      if (!field) return "";
      return field.type;
    },
    onSelectAdded(items) {
      for (let item of items) {
        let selectedIndex = this.stage.fields.indexOf(item);
        if (selectedIndex >= 0) {
          this.stage.fields.splice(selectedIndex, 1);
        }
      }
    },
    onSelectAvailable(items) {
      for (let item of items) {
        // this.stage.fields.push(item);
        this.stage.fields.push({
          fieldId: item.id,
          id: 0,
          required: null,
          isMandaroryAttachment: null,
        });
      }
    },
  },
  watch: {},
};
</script>